<template>
  <div
    class="sidebar-wrapper d-flex justify-content-between flex-column flex-grow-1"
  >
    <div class="p-2">
      <div class="mt-3">
        <h5 class="app-label section-label mb-2">
          <span class="align-middle">Tipo de evento</span>
        </h5>
        <b-form-group>
          <b-form-checkbox-group
            v-model="selectedContent"
            name="event-filter"
            stacked
          >
            <b-form-checkbox
              v-for="(item, index) in calendarContentOptions"
              :key="index"
              name="event-filter"
              :value="item.id"
              class="mb-1"
              :class="`${item.color}-border`"
              :checked="true"
            >
              {{ item.name }}
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </div>
      <div class="mt-3">
        <h5 class="app-label section-label mb-2">
          <span class="align-middle">Tipo de evento</span>
        </h5>
        <b-form-group>
          <b-form-checkbox-group
            v-model="selectedDisclosureType"
            name="event-filter"
            stacked
          >
            <b-form-checkbox
              v-for="(item, index) in disclosureTypeOptions"
              :key="index"
              name="event-filter"
              :value="item.id"
              class="mb-1"
              :class="`${item.color}-border`"
              :checked="true"
            >
              {{ item.name }}
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </div>
    </div>
    <!-- <b-img :src="require('@/assets/images/pages/calendar-illustration.png')" /> -->
  </div>
</template>

<script>
import {
  BButton,
  BFormGroup,
  BFormCheckboxGroup,
  BFormCheckbox,
  BImg,
  // BListGroup,
  // BListGroupItem,
} from "bootstrap-vue";
import useCalendarSidebar from "./useCalendarSidebar";
import store from "../../../../store/store";
import vSelect from "vue-select";
import AppConstants from "../../../../appConstants";
import { CONTENT } from "../../../../enums/enum-content";

export default {
  directives: {},
  components: {
    BButton,
    BImg,
    BFormCheckbox,
    BFormGroup,
    BFormCheckboxGroup,
    vSelect,
    // BListGroup,
    // BListGroupItem,
  },
  props: {
    isEventHandlerSidebarActive: {
      type: Boolean,
      require: true,
    },
  },
  data() {
    return {
      disclosureTypeOptions: AppConstants.DISCLOSURE_TYPE_LIST,
      selectedDisclosureType: [],
      newsTypeOptions: [],
      selectedNewsType: [],
      selectedOrigins: [],
      originOptions: [],
      calendarContentOptions: [
        { id: CONTENT.CONSULTING_COURSES, name: "Cursos e Eventos" },
        { id: CONTENT.CONSULTING_SPEECHES, name: "Palestras" },
      ],
      selectedContent: [
        CONTENT.CONSULTING_COURSES,
        CONTENT.CONSULTING_SPEECHES,
      ],
    };
  },
  created() {
    this.selectedDisclosureType = AppConstants.DISCLOSURE_TYPE_LIST.map(
      (item) => item.id
    );
  },
  methods: {
    isRegionSelected(region) {
      // console.log(store.state.calendar.selectedRegion);
      return region.id == store.state.calendar.selectedRegion;
    },
    selectRegion(region) {
      // console.log('selectRegion', region.id)
      store.commit("calendar/SET_SELECTED_REGION", region.id);
      this.$forceUpdate();
    },
  },
  computed: {},
};
</script>

<style>
</style>
